import { Component, ChangeDetectionStrategy } from '@angular/core';

import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environment/environment';

@Component({
  selector: 'app-duna-catering-groups-create-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
  ],
  template: `
    <h2 mat-dialog-title>Opret forplejningsgruppe</h2>
    <mat-dialog-content>
      <form [formGroup]="form" class="form">
        <mat-form-field appearance="outline">
          <mat-label>Navn *</mat-label>
          <input matInput formControlName="name" autocomplete="off" />
          @if (form.get('name')?.hasError('required')) {
          <mat-error>Navn er påkrævet</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Beskrivelse</mat-label>
          <textarea matInput formControlName="description" rows="3"></textarea>
        </mat-form-field>
        @if (error) {
        <p class="error">{{ error }}</p>
        }
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        mat-stroked-button
        (click)="dialogRef.close(false)"
        [disabled]="isSubmitting"
      >
        Annuller
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="form.invalid || isSubmitting"
        (click)="onSave()"
      >
        Opret
      </button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .form {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 420px;
        padding-top: 8px;
      }
      mat-form-field {
        width: 100%;
      }
      .error {
        color: #f44336;
        font-size: 0.875rem;
      }
    `,
  ],
})
export class DunaCateringGroupsCreateDialogComponent {
  form: FormGroup;
  isSubmitting = false;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<DunaCateringGroupsCreateDialogComponent>,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: [''],
    });
  }

  onSave(): void {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;
    this.http
      .post(`${environment.apiUrl}/events/catering/groups`, {
        name: this.form.value.name.trim(),
        description: this.form.value.description?.trim() || null,
      })
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: (err) => {
          this.isSubmitting = false;
          this.error = err?.error?.message || 'Der opstod en fejl.';
        },
      });
  }
}
